module.exports = __webpack_public_path__ + "assets/retina_AngleMidpointDetailed.c6748bb8ad490425efe5ce3af30475b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_AngleMidpointDetailed.png
// module id = 621
// module chunks = 0